export interface Age {
	years: number
	months: number
}

export default (years: number): Age => ({ years: Math.floor(years), months: Math.round(years * 12) % 12 })
